import React from "react";

export default function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section className="relative h-[55vh] min-h-[400px] flex items-end" data-testid="page-hero">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src={image}
          alt=""
          className="w-full h-full object-cover animate-slow-zoom"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/40 to-black/80" />
      </div>
      <div className="container-tti relative z-10 pb-16 pt-24">
        {eyebrow && <div className="eyebrow text-marigold mb-4 animate-fade-up">{eyebrow}</div>}
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-white tracking-tighter leading-[0.95] max-w-4xl animate-fade-up">
          {title}
        </h1>
        {subtitle && (
          <p className="text-white/85 text-lg max-w-2xl mt-6 font-light leading-relaxed animate-fade-up">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
